import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rrdisplay-user',
  templateUrl: './rrdisplay-user.component.html',
  styleUrls: ['./rrdisplay-user.component.scss']
})
export class RRDisplayUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
